<!-- <div class="innerBanner" style="background-image: url('{{ privacyDetails.bannerImage }}')"> -->
<!-- <img
      [src]="privacyDetails.bannerImage ? privacyDetails.bannerImage : '../../../assets/images/NoImage.jpg'"
      style="width: 100%"
    /> -->
<!-- <div class="bannerText"></div>
</div> -->

<div
  class="innerBanner"
  [style.background-image]="'url(' + privacyDetails.bannerImage + ')'"
  (click)="imageClick(0)"
></div>

<p-galleria
  [(value)]="images"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [fullScreen]="true"
  [showItemNavigators]="false"
  [baseZIndex]="100000"
  [containerStyle]="{ 'max-width': '90%' }"
>
  <ng-template pTemplate="item" let-item>
    <img [src]="item" class="gallery-image" />
  </ng-template>
</p-galleria>

<!-- <nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="/home">Home</a></li>
    <li class="breadcrumb-item active" aria-current="page">{{ privacyDetails.bannerTitle }}</li>
  </ol>
</nav> -->

<div class="container contentPanel">
  <!-- <app-breadcrumb></app-breadcrumb> -->
  <nav aria-label="breadcrumb" class="breadcrumbPrivacy">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a href="/home">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">{{ privacyDetails.bannerTitle }}</li>
    </ol>
  </nav>
  <!-- <h1>{{ privacyDetails.bannerTitle }}</h1> -->
  <div class="pageTitle">
    <div class="privacyPolicy" #privacyPolicy></div>
    <!-- <p [innerHTML]="privacyDetails.content"></p> -->
    <div
      name="termly-embed"
      data-id="51208ed8-e697-4f8d-9877-850f7843cd60"
      data-type="iframe"
      class="privacyPolicyIframe"
    ></div>
  </div>
</div>
